"use client";

import { SessionProvider } from "next-auth/react";

type SessionProviderProps = React.ComponentProps<typeof SessionProvider>;

/**
 * Wrapper for SessionProvider. Can't use SessionProvider directly in server components because it's a client
 * context, os have this component as a use client wrapper so it can be rendered in server components.
 */
export default function NextAuthSessionProvider({ session, children }: SessionProviderProps) {
    return (
        <SessionProvider
            session={session}
            refetchOnWindowFocus
            // Every 7 minutes. Access token lasts for 45 minutes, refresh happens 10 minutes before so 7
            // minutes gives 2 opportunities, to refresh before the next API call.
            refetchInterval={7 * 60}
        >
            {children}
        </SessionProvider>
    );
};
